<script>
import { mapGetters, mapActions } from 'vuex'

import mapStoreValue from '@/util/mapStoreValue'

export default {

  computed: {

    ...mapGetters([
      'currentLevelId',
      'currentLevelName',
      'turnsCompleted',
      'nextLevelId',

      'playerDirection',
      'connectedPlayerNodes'
    ]),

    debugControlsVisible: mapStoreValue('debugControlsVisible', 'setDebugControlsVisible'),
    cameraFollowsPlayer: mapStoreValue('cameraFollowsPlayer', 'setCameraFollowsPlayer'),
    cameraPositionX: mapStoreValue('cameraPositionX', 'setCameraPositionX'),
    cameraPositionY: mapStoreValue('cameraPositionY', 'setCameraPositionY'),
    cameraDistance: mapStoreValue('cameraDistance', 'setCameraDistance'),
    cameraElevation: mapStoreValue('cameraElevation', 'setCameraElevation'),
    playerCameraIsActive: mapStoreValue('playerCameraIsActive', 'setPlayerCameraIsActive')

  },

  methods: {

    ...mapActions([
      'resetGameplayState'
    ]),

    toggle () {
      this.debugControlsVisible = !this.debugControlsVisible
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-debug-controls-visible': debugControlsVisible,
      'c-debug-controls-hidden': !debugControlsVisible
    }"
    class="c-debug-controls"
  >

    <button
      class="c-debug-controls-hide-button"
      @click="toggle"
    >
      {{ turnsCompleted }} ↕
    </button>



    <div
      v-if="!debugControlsVisible"
      class="c-debug-controls-content"
    >

      <div class="c-debug-controls-heading">
        Level {{ currentLevelName }} ({{ currentLevelId }})
      </div>

      <div class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Direction to face
        </div>

        <div class="c-debug-controls-item-control">
          {{ Math.round(playerDirection) }} deg
        </div>

      </div>

      <div class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Player node
        </div>

        <div class="c-debug-controls-item-control">
          {{ $store.getters.playerNodeId }} ({{ $store.getters.playerNode.x }} / {{ $store.getters.playerNode.y }})
        </div>

      </div>

      <div class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Cursor node
        </div>

        <div class="c-debug-controls-item-control">
          {{ $store.getters.cursorNodeId }} ({{ $store.getters.cursorNode.x }} / {{ $store.getters.cursorNode.y }})
        </div>

      </div>

      <div
        v-if="$store.getters.nextLevelId"
        class="c-debug-controls-item"
      >
        <div class="c-debug-controls-item-control">
          <router-link
            :to="{
              name: 'level',
              params: {
                levelId: $store.getters.nextLevelId
              }
            }"
          >
            Next level
          </router-link>
        </div>
      </div>



      <div class="c-debug-controls-heading">
        Camera
      </div>

      <label class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Player camera
        </div>

        <div class="c-debug-controls-item-control">
          <input
            v-model="playerCameraIsActive"
            type="checkbox"
          >
        </div>

      </label>

      <label class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Camera follows player
        </div>

        <div class="c-debug-controls-item-control">
          <input
            v-model="cameraFollowsPlayer"
            type="checkbox"
          >
        </div>

      </label>

      <label
        v-if="!cameraFollowsPlayer"
        class="c-debug-controls-item"
      >

        <div class="c-debug-controls-item-label">
          Camera position x/y
        </div>

        <div class="c-debug-controls-item-control">

          <input
            v-model.number="cameraPositionX"
            min="-40"
            max="40"
            type="number"
          >

          <input
            v-model.number="cameraPositionY"
            min="-40"
            max="40"
            type="number"
          >

        </div>

      </label>

      <label class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Camera distance
        </div>

        <div class="c-debug-controls-item-control">
          <input
            v-model.number="cameraDistance"
            min="5"
            max="40"
            type="number"
          >
        </div>

      </label>

      <label class="c-debug-controls-item">

        <div class="c-debug-controls-item-label">
          Camera elevation
        </div>

        <div class="c-debug-controls-item-control">
          <input
            v-model.number="cameraElevation"
            min="2"
            max="40"
            type="number"
          >
        </div>

      </label>



      <div class="c-debug-controls-item">
        <div class="c-debug-controls-item-control">

          <button @click="resetGameplayState">
            Reset stage
          </button>

        </div>
      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-debug-controls {
  @include radius;
  @include no-overflow;
  @include small-font;
  @include scroll-vertical;
  max-height: 90vh;
  background-color: translucent($black, 0.75);

  a,
  button {
    @include pad-tight;
    @include inline-block;
    background-color: translucent($white, 0.15);

    &:hover {
      background-color: translucent($white, 0.25);
    }

  }

  label {

    &:hover {
      background-color: translucent($white, 0.15);
    }

  }

}

.c-debug-controls-content {
  @include grid;
  z-index: 1;
}



.c-debug-controls-hide-button {
  top: 0;
  right: 0;
  z-index: 2;
}

.c-debug-controls-hidden {
  @include pad-vertical;

  .c-debug-controls-hide-button {
    position: absolute;
  }
}



.c-debug-controls-heading {
  @include pad-tight;
  @include strong;
  @include no-push-vertical;
  opacity: 0.4;
}

.c-debug-controls-item {
  @include flex;
  @include flex-center;
}

.c-debug-controls-item-label,
.c-debug-controls-item-control {
  @include pad-tight;
}

.c-debug-controls-item-label {
  @include flex-fixed;
  width: 12em;
}

.c-debug-controls-item-control {
  @include flex-fluid;
  width: 7em;
}

</style>
